import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-tag-1",
  "use": "icon-si-glyph-tag-1-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-tag-1\" id=\"icon-si-glyph-tag-1\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>955</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M5.546,15.951 C5.037,16.46 5.031,10.969 5.031,10.969 C5.031,10.969 -0.462,10.962 0.0480000001,10.453 L10.061,0.439 C10.569,-0.069 11.418,-0.045 11.957,0.492 L15.507,4.043 C16.046,4.582 16.068,5.431 15.561,5.939 L5.546,15.951 L5.546,15.951 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-tag-1.svg
// module id = H/Gb
// module chunks = 62